<template>
  <tabs>
    <tab name="Info">
      <product-info-editor :product="product"
                           :categories="categories"></product-info-editor>
    </tab>

    <tab name="Gallery">
      <product-images :product="product"></product-images>
    </tab>

    <tab name="Videos">
      <products-videos :product="product"></products-videos>
    </tab>

    <tab name="Specs">
      <product-specs :product="product"></product-specs>
    </tab>

    <tab name="Benefits">
      <product-benefits :product="product"></product-benefits>
    </tab>

    <tab name="Downloads">
      <product-downloads :product="product"></product-downloads>
    </tab>

    <tab name="Prices">
      <product-prices :product="product"></product-prices>
    </tab>
  </tabs>
</template>

<script>
import ProductImages from "./ProductImages";
import ProductInfoEditor from "./ProductInfoEditor";
import ProductsVideos from "./ProductsVideos";
import ProductSpecs from "./ProductSpecs";
import ProductBenefits from "./ProductBenefits";
import ProductDownloads from "./ProductDownloads";
import ProductPrices from "./ProductPrices";

export default {
  name: "ProductEditor",
  components: {
    ProductPrices,
    ProductDownloads, ProductBenefits, ProductSpecs, ProductsVideos, ProductInfoEditor, ProductImages
  },
  data() {
    return {
      loading: false,
      product: {
        images: [],
        videos: [],
        specs: [],
        benefits: [],
        downloads: [],
        options: [],
      },
      categories: []
    }
  },
  mounted() {
    this.product = JSON.parse($("#product").text())
    this.categories = JSON.parse($("#categories").text())
  },
  methods: {},
  computed: {}
}
</script>
